"use strict";

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("../../utils");

var _anchorProps = require("./constants/anchorProps");

var _styles = require("./styles");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  'data-testid': _propTypes.string,
  'aria-label': _propTypes.string,
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  gaAction: _propTypes.string,
  gaCategory: _propTypes.string,
  href: _propTypes.string,
  rel: (0, _propTypes.oneOf)(_anchorProps.relOptions),
  target: (0, _propTypes.oneOf)(_anchorProps.targetOptions)
} : {};
var defaultProps = {
  'data-testid': 'Link'
};

var Link = function Link(_ref) {
  var dataTestId = _ref['data-testid'],
      ariaLabel = _ref['aria-label'],
      children = _ref.children,
      gaAction = _ref.gaAction,
      gaCategory = _ref.gaCategory,
      href = _ref.href,
      rel = _ref.rel,
      target = _ref.target,
      others = _objectWithoutProperties(_ref, ["data-testid", "aria-label", "children", "gaAction", "gaCategory", "href", "rel", "target"]);

  var element = href && children ? 'a' : 'span';
  var isInternalLink = href == null ? void 0 : href.includes('www.creditas');
  var linkType = isInternalLink ? 'inbound' : 'outbound';
  var linkRel = !rel && !isInternalLink ? 'noopener' : rel;
  var linkLabel = typeof children === 'string' ? children : ariaLabel;
  var linkEventAction = [gaAction, linkLabel].filter(Boolean).join(' | ');

  var handleLinkClick = function handleLinkClick(_ref2) {
    var eventAction = _ref2.eventAction,
        eventCategory = _ref2.eventCategory,
        eventLabel = _ref2.eventLabel;
    return (0, _utils.dispatchFooterEvent)({
      action: "".concat(linkType, " links | ").concat(eventAction == null ? void 0 : eventAction.toLowerCase()),
      category: eventCategory == null ? void 0 : eventCategory.toLowerCase(),
      label: eventLabel
    });
  };

  return children && (0, _core.jsx)(_styles.Wrapper, (0, _extends2.default)({
    as: element,
    "data-testid": dataTestId,
    href: href,
    rel: _anchorProps.relOptions.includes(linkRel) ? linkRel : null,
    target: _anchorProps.targetOptions.includes(target) ? target : null,
    onClick: function onClick() {
      return handleLinkClick({
        eventAction: "".concat(linkEventAction) || '',
        eventCategory: gaCategory || '',
        eventLabel: href || ''
      });
    }
  }, others), children) || null;
};

exports.Link = Link;
process.env.NODE_ENV !== "production" ? Link.propTypes = propTypes : void 0;
Link.defaultProps = defaultProps;
Link.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Link",
  "props": {
    "data-testid": {
      "defaultValue": {
        "value": "'Link'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "aria-label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": ""
    },
    "gaAction": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "gaCategory": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "href": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "rel": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "relOptions"
      },
      "required": false,
      "description": ""
    },
    "target": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "targetOptions"
      },
      "required": false,
      "description": ""
    }
  }
};